import { render, staticRenderFns } from "./MarketPushZone.vue?vue&type=template&id=5322c1af&scoped=true&"
import script from "./MarketPushZone.vue?vue&type=script&lang=js&"
export * from "./MarketPushZone.vue?vue&type=script&lang=js&"
import style0 from "./MarketPushZone.vue?vue&type=style&index=0&id=5322c1af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322c1af",
  null
  
)

export default component.exports